export const CANCELLATION_MESSAGES = {
  flow: () => ({
    confirmBody:
      "Running tasks may be interrupted. Are you sure you want to proceed?",
    confirmTitle: "Cancel Execution Flow?",
    errorTitle: "Cancellation failed",
    successBody: "The execution flow will stop as soon as possible.",
    successTitle: "Cancellation requested",
  }),

  task: (taskId: string) => ({
    confirmBody:
      "This may interrupt in-flight work. Are you sure you want to proceed?",
    confirmTitle: `Cancel Task ${taskId}?`,
    errorTitle: "Failed to cancel task",
    successBody: `Task ${taskId} will be cancelled shortly.`,
    successTitle: "Cancellation requested",
  }),
};
